module.exports = __webpack_public_path__ + "static/media/slider3.cf2dc8ab.png";